import {
  keysToCamelCase,
  removeUndefinedValues,
} from '@wix/wix-vod-shared/dist/src/common/utils/object';
import { convertSSToMMSS } from 'shared/utils/time';
import { FREE_VIDEO_DEAL_INFO } from '@wix/wix-vod-constants/dist/common/video-deal-info';
import {
  TRANSCODING_STATUSES,
  TRANSCODING_STATUSES_V2,
} from '@wix/wix-vod-constants/dist/common/transcoding-statuses';
import { VIDEO_SOURCES } from '@wix/wix-vod-constants/dist/common/video-sources';
import { getDownloadUrl, getVideoUrls } from 'api/public/video/video';
import { normalizeId } from 'api/normalizers/entity-id';

const DEFAULT_DOWNLOAD_OPTIONS = { allowDownload: false };

const normalizeTranscodingStatus = status =>
  status === TRANSCODING_STATUSES_V2.INIT ? TRANSCODING_STATUSES.NONE : status;

export const parseVideoItem = itemData => {
  if (!itemData) {
    return null;
  }

  itemData = keysToCamelCase(itemData);

  const {
    itemId,
    externalId,
    listId,
    mediaStatus,
    trailerStatus,
    mediaInfo,
    mediaExternUrl,
    downloadOptions: { allowDownload } = DEFAULT_DOWNLOAD_OPTIONS,
    videoSource = VIDEO_SOURCES.COMPUTER,
  } = itemData;

  const id = (itemId && normalizeId(itemId)) || externalId;

  let {
    customCoverUrl = null,
    createdTs,
    updatedTs,
    publishTs,
    dealInfo,
    usedInLists,
    durationSec,
    durationStr,
    tags = [],
    categories = [],
  } = itemData;

  createdTs = new Date(createdTs * 1000);
  updatedTs = new Date(updatedTs * 1000);

  if (publishTs) {
    publishTs = new Date(publishTs * 1000);
  }

  //TODO think about refactor to keep refs in 'usedInLists'
  const listsRefs = _.reduce(
    usedInLists,
    (refs, listItem) => ({ ...refs, [listItem.itemId]: listItem.refItemId }),
    {},
  );

  usedInLists = _.map(usedInLists, ({ itemId, title }) => ({
    id: itemId,
    title,
  }));

  const fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);

  if (fileInputDurationSec) {
    durationSec = Math.floor(fileInputDurationSec / 1000);
    durationStr = convertSSToMMSS(durationSec);
  }

  if (!durationStr) {
    durationStr = convertSSToMMSS(durationSec);
  }

  const transcodingStatus = normalizeTranscodingStatus(
    mediaExternUrl
      ? TRANSCODING_STATUSES.READY
      : mediaStatus || TRANSCODING_STATUSES.NONE,
  );

  const trailerTranscodingStatus = normalizeTranscodingStatus(
    trailerStatus || TRANSCODING_STATUSES.NONE,
  );

  // external videos should be free
  if (mediaExternUrl) {
    dealInfo = FREE_VIDEO_DEAL_INFO;
  }

  tags = _.uniq(tags);
  categories = _.uniq(categories);

  const normalizedListId = normalizeId(listId);

  // TODO: add mapping instead assign
  itemData = _({})
    .assign(itemData, {
      id,
      listId: normalizedListId,
      customCoverUrl,
      transcodingStatus,
      trailerTranscodingStatus,
      dealInfo,
      durationSec,
      durationStr,
      createdTs,
      updatedTs,
      publishTs,
      usedInLists,
      listsRefs,
      getVideoUrls: instance =>
        getVideoUrls(itemId, normalizedListId, instance),
      getDownloadUrl: instance =>
        getDownloadUrl(itemId, normalizedListId, instance),
      allowDownload,
      videoSource,
      tags,
      categories,
    })
    .omit('downloadOptions', 'mediaStatus', 'trailerStatus')
    .value();

  return removeUndefinedValues(itemData);
};
